import { NavLink } from "react-router-dom"
import { AppSpan, FlexRow } from "src/style"
import { options } from './options'
import * as device from 'react-device-detect'

export const PublicMenu: React.FC<any> = () => {
    
    return (
        <FlexRow gap='1' justifyContent='flex-start'>
            {
                options?.map((item, index) => {
                    return (
                        <NavLink
                            to={item?.path}
                            key={index}
                            className={({ isActive }) => `default-menu ${isActive && 'active-menu'}`}
                        >
                            <AppSpan 
                                color='#ffffff' textSize='1.6' 
                                fontWeight={(device.isWindows && device.isDesktop) ? '400' : '500'}
                                cursor='pointer'
                            >
                                {item.title}
                            </AppSpan>
                        </NavLink>
                    )
                })
            }
        </FlexRow>
    )
}